import { render, staticRenderFns } from "./M_permit.vue?vue&type=template&id=35f51469&scoped=true&"
import script from "./M_permit.vue?vue&type=script&lang=js&"
export * from "./M_permit.vue?vue&type=script&lang=js&"
import style0 from "./M_permit.vue?vue&type=style&index=0&id=35f51469&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f51469",
  null
  
)

export default component.exports